import PageLayout from './Index.vue'

PageLayout.install = function(Vue) {
  Vue.component(PageLayout.name, PageLayout)
}

export default PageLayout
